import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const DeleteVideoNoteModal = ({
  loading,
  handleSubmit,
  videoNotesDeleteModal,
  handleModalClose,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={videoNotesDeleteModal.status}>
      <ModalHeading heading={t('screens.chat.deleteVideoNote')} />
      {loading ? (
        <DeleteModalSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection style={{ width: '34rem' }}>
            <p className='primaryText'>{t('screens.chat.confirmDeletePrompt')}</p>
            <p className='dangerText'>
              {t('screens.chat.deleteNoteWarn')}
            </p>
          </InputsSection>

          <ModalButtons
            submitButtonLabel={t('screens.chat.deleteNoteBtn')}
            onSubmit={handleSubmit}
            cancelButtonLabel={t('screens.chat.cancel')}
            onCancel={handleModalClose}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default DeleteVideoNoteModal;
